import { render, staticRenderFns } from "./EcpFilaColumna.vue?vue&type=template&id=0c76fee4"
import script from "./EcpFilaColumna.vue?vue&type=script&lang=js"
export * from "./EcpFilaColumna.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports